import { collectFrameExtentPoints } from '@toolproof-core/visualization/rendering/_pure/frame-bounds';
import type { Vector3Tuple } from '@toolproof-core/visualization/_contract/geometry';
import type { SpaceDerivationFrame } from '@toolproof-core/visualization/derivation/_contract/derivation';

export function deriveWorkflowOverviewEnvelope(
    frame: SpaceDerivationFrame,
    extentPoints?: Vector3Tuple[],
): { center: Vector3Tuple; points: Vector3Tuple[] } | undefined {
    const points = extentPoints ?? collectFrameExtentPoints(frame);
    if (points.length === 0) return undefined;
    // Workflow rings share the world origin. Retaining it as target preserves their visual centre.
    // Interior points cannot enlarge the convex envelope; protruding augmentation is included automatically.
    return { center: [0, 0, 0], points };
}
